import { defineStore } from 'pinia'

interface MenuState {
  visible: boolean
}

export const useMenuStore = defineStore('menu', {
  state: (): MenuState => ({
    visible: false,
  }),
  actions: {
    panelClose() {
      document.body.classList.remove('modal-open')
      this.visible = false
    },
    panelOpen() {
      document.body.classList.add('modal-open')
      this.visible = true
    },
    switchPanel() {
      this.visible = !this.visible
    }
  },
  getters: {
    menuPanelVisible(): boolean {
      return this.visible
    }
  }
})